<template>
    <div class="modelList_box">
        <div class="app_container">
            <div class="modelList_header">
                <ul class="modelList_items">
                    <li class="modelList_item" v-for="(dix,index) in showList" v-bind:key="index">
                        <div class="modelList_thumbnails dix_img_box" v-bind:style="{backgroundImage:'url(\''+ dix.preview +'\''}">
                            <div class="bottom_left tooltip-box top" v-if="dix.doc && dix.doc != ''" data-content="查看文档" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" @click.stop="viewDixDocument(dix,true)" title="">
                                <i class="fa fa-file-text-o tooltip-box top" data-content="查看文档" style="font-size:1.2em;"></i>
                            </div>
                            <span class="indexAPP"><i>{{index+1}}</i></span>
                            <div class="isPay" @click.stop="useItem(dix)">
                                使用
                            </div>
                        </div>
                        <hr/>
                        <div class="modelList_info projectList_info">
                            <div class="author_info city_author_info">
                                <a class="tooltip-box top" style = "cursor:auto">
                                    <img class="author_headImg" src="../../static/img/dix.png">
                                </a>
                                <span class="author_name" style="max-width:200px;" v-html="$options.filters.highLightMsg(dix.name)" v-bind:title="dix.name" @dblclick="selectText()">{{dix.name}}</span>
                            </div>
                            <div class="model_info">
                                <div class="model_seen model_time tooltip-box top"  v-bind:data-content="processingTime(dix.createTime)" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_seen tooltip-box top" data-content="使用次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-eye fa-fw"></i>{{formatNumber(dix.view)}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modelList_footer">
                <h4 class="text_muted" v-if="!isLoadComplete">加载中...</h4>
				<div class="load_more_btn" v-on:click="loadMore" v-if="!isLastPage&&isLoadComplete">加载更多<i class="fa fa-arrow-circle-o-down"></i></div>
				<h4 v-if="isLastPage" class="text_muted">已显示全部</h4>
			</div>
        </div>
    </div>
</template>
<script>
    import bus from '../assets/js/eventBus.js';
    import crypto from 'crypto-browserify';
    import Identicon from 'identicon.js';
    import shield from '../assets/js/shield.js';
    var vm;
    export default {
        name:"dix_box",
        components:{},
        data:function(){
            return {
                Path: "https://www.thingjs.com/citybuilder_console/",
                viewPath:"https://www.thingjs.com/citybuilder/#/projectPreview?model=preview&logo=false&template=false",
                imgPath : "https://www.thingjs.com",
                showList:[],
                queryData: {
                    type:"",
                    bigType: "",
                    smallType: "",
                    keyWord: "",
                    pageSize: 24,
                    pageNumber: 1,
                    sort: "zonghe"
                },
                isLastPage:false,
                message:[],
                infoShow:false,
                dixListNum:'',
                index:0,
                isLoadComplete :false,
                panelShow:false,
                openUrl:''
            };
        },
        methods:{
            selectText(){
                document.getSelection().selectAllChildren(document.getSelection().focusNode.parentNode);
                document.execCommand('copy');
            },
            queryDixList:function(data){
                var _this = this;
                var _list = this.showList;
                _this.isLoadComplete = true;
                this.$reqs.post("/scene/dix", data).then(function(result) {
                    if(result && result.data.state) {
                        var content = result.data.content;
                        var contentLen = content.length;
                        bus.$emit('changeListCount',result.data.recordCount);
                        _this.dixListNum = result.data.recordCount;
                        for(var i = 0; i < contentLen; i++) {
                            _list.push(content[i]);
                        }
                        _this.isLastPage = result.data.recordCount <= result.data.pageNumber*result.data.pageSize;
                    }else{
                        console.log('querydixList error');
                    }
                }).catch(function(error) {
                    console.log('querydixList error'+error);
                });
            },
            showTooltip: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
            },
            cancelTooltip: function(event) {
                $("div").remove(".tooltips");
            },
            formatNumber: function(number) {
                if(number < 1000) {
                    return number;
                } else {
                    return(number / 1000).toFixed(1) + "k";
                }
            },
            loadMore: function() {
                this.queryData.pageNumber++;
                this.queryDixList(this.queryData);
            },
            processingTime: function(time) {
                var str = time.toString();
                return str;
            },
            useItem:function(dix){
                var _this = this;
                if($.cookie('openid')){
                    var openUrl= 'https://dix.thingjs.com'+dix.useTemplate;
                    window.open(openUrl,"_blank");
                    _this.$reqs.get("/scene/addDixView?id="+dix.id).then(function(result) {})
                }else{
                    logoinForStore();
                }
            },
            viewDixDocument:function(dix){
                if($.cookie('openid')){
                    var openUrl= dix.doc;
                    window.open(openUrl,"_blank");
                 }else{
                    logoinForStore();
                }
            },
        },
        beforeCreate() {
            vm = this;
        },
        beforeDestroy(){
            bus.$off("addDixList");
            bus.$off("changeDixList");
            bus.$off("showDixNull");
        },
        mounted(){
            var _this = this;
            if(shield.shieldWords.indexOf($("#keyword").val())=='-1'){
                this.queryData.keyWord = $("#keyword").val();
            }
            this.queryData.sort = $('.active').attr('data-sort');
            this.queryDixList(this.queryData);
            bus.$on("changeDixList",(data) =>{
                _this.showList = [];
                _this.queryDixList(data);
                _this.queryData = JSON.parse(JSON.stringify(data));
            });
            bus.$on("showDixNull",(data) =>{
                _this.showList = [];
                bus.$emit('changeListCount','-1');
                _this.isLastPage = true;
            });
            bus.$on("addDixList", (data) => {
                _this.queryData.pageNumber++;
                _this.queryDixList(_this.queryData);
            });
            // bus.$on("dixList",(data) => {
            //     this.viewDix(data,false);
            // })
            
        },
        filters:{
            highLightMsg:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return value;
                    }
                }else{
                    return value;
                }
            },
            highLightkeyWord:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }
        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/dix.vue